export default "__VITE_ASSET__CimXAbI$__"